import React, { Component } from 'react';
import { StyledHeader } from '../styles';
import ParnerLogo from '../../Content/Shared/PartnerLogo';

class WaooHeader extends Component {
  render() {
    return (
      <StyledHeader background="#282828" boxShadow="none">
        <ParnerLogo
          getTranslation={(messageCode) => this.props.getTranslation(messageCode)}
          isHeaderLogo={true}
        />
      </StyledHeader>
    );
  }
}

export default WaooHeader;
